import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import ResponsiveNavbar from "./responsive-navbar";
import ResponsiveSidebar from "./responsive-sidebar";

/**
 * ResponsiveShell — wraps every mobile route with the navbar + sidebar chrome
 * that nya-responsive provides via its _app.js layout.
 *
 * This mirrors the Semantic-UI Sidebar.Pushable / Sidebar.Pusher pattern
 * from nya-responsive, but implemented in plain React for nya-web.
 */
class ResponsiveShell extends Component {
  constructor(props) {
    super(props);
    this.state = { sidebarOpen: false };
    this.toggleSidebar = this.toggleSidebar.bind(this);
    this.closeSidebar = this.closeSidebar.bind(this);
    this.openSidebar = this.openSidebar.bind(this);
  }

  componentDidMount() {
    window.addEventListener("NYA_OPEN_RESPONSIVE_SIDEBAR", this.openSidebar);
  }

  componentWillUnmount() {
    window.removeEventListener("NYA_OPEN_RESPONSIVE_SIDEBAR", this.openSidebar);
  }

  toggleSidebar() {
    this.setState((prev) => ({ sidebarOpen: !prev.sidebarOpen }));
  }

  closeSidebar() {
    this.setState({ sidebarOpen: false });
  }

  openSidebar() {
    this.setState({ sidebarOpen: true });
  }

  handleOverlayPress = (event) => {
    if (event.type === "click" && event.detail > 0) return;
    this.closeSidebar();
  };

  render() {
    const { location } = this.props;
    const { sidebarOpen } = this.state;
    const pathname = (location && location.pathname) || "";
    const isNewsRoute = /^\/news(\/|$)/.test(pathname);

    return (
      <div className={`responsive-shell ${isNewsRoute ? "news-route" : ""}`}>
        <ResponsiveSidebar open={sidebarOpen} onClose={this.closeSidebar} />
        <div
          className="responsive-shell-pusher"
          style={{
            WebkitTransform: sidebarOpen ? 'translate3d(288px,0,0)' : 'translate3d(0,0,0)',
            transform: sidebarOpen ? 'translate3d(288px,0,0)' : 'translate3d(0,0,0)',
            WebkitTransition: '-webkit-transform 0.25s ease',
            transition: 'transform 0.25s ease',
            WebkitBackfaceVisibility: 'hidden',
            backfaceVisibility: 'hidden',
            position: 'absolute',
            top: 0, left: 0, right: 0, bottom: 0,
            zIndex: 1,
          }}
        >
          {!isNewsRoute && (
            <ResponsiveNavbar
              sidebarOpen={sidebarOpen}
              onToggleSidebar={this.toggleSidebar}
            />
          )}
          <div
            role="button"
            tabIndex={-1}
            aria-label="Close menu"
            className={`responsive-shell-overlay ${sidebarOpen ? "active" : ""}`}
            onPointerUp={this.handleOverlayPress}
            onClick={this.handleOverlayPress}
          />
          <div className="responsive-shell-content">
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ResponsiveShell);
